import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { DEVICE_TABS, type DeviceTab } from '@/features/admin/shared/tabs';
import { DeviceDetailPage } from '@/features/admin/devices/device-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'un appareil. L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/resources/devices/$deviceId')({
  validateSearch: (search: Record<string, unknown>): { tab: DeviceTab } => ({
    tab: DEVICE_TABS.parse(search['tab']),
  }),
  component: DeviceRoute,
});

function DeviceRoute() {
  const { tenant, deviceId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="devices"
      crumbs={[{ label: t('nav.items.devices') }, { label: deviceId, mono: true }]}
    >
      <DeviceDetailPage
        tenantId={tenant}
        deviceId={deviceId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
